module.exports = "<nb-layout>\r\n  <nb-layout-column>\r\n\r\n    <div class=\"col-xl-4 col-lg-6 col-md-8 col-sm-12 \">\r\n      <h1 class=\"brand-login\"></h1>\r\n      <router-outlet></router-outlet>\r\n    </div>\r\n  </nb-layout-column>\r\n</nb-layout>"


//////////////////
// WEBPACK FOOTER
// ./src/framework/auth/components/auth.component.html
// module id = ./src/framework/auth/components/auth.component.html
// module chunks = main